import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useUserStore } from '@/store/userStore';
import { resolveAppLocale, type AppLocale } from './resolveAppLocale';

const LOCALE_STORAGE_KEY = 'ayw_app_locale';

/**
 * 앱 전역 locale 훅.
 * userStore의 preferredLanguage가 변경되면 i18next 언어를 동기화한다.
 * App.tsx 루트에서 1회 호출.
 */
export function useAppLocale(): AppLocale {
  const { i18n } = useTranslation();
  const preferredLanguage = useUserStore((s) => s.user?.preferredLanguage);

  useEffect(() => {
    if (!preferredLanguage) {
      document.documentElement.lang = i18n.language;
      return;
    }

    const appLocale = resolveAppLocale(preferredLanguage);
    if (i18n.language !== appLocale) {
      void i18n.changeLanguage(appLocale);
    }
    document.documentElement.lang = appLocale;
    try {
      localStorage.setItem(LOCALE_STORAGE_KEY, appLocale);
    } catch {
      // quota exceeded — ignore
    }
  }, [preferredLanguage, i18n]);

  return i18n.language as AppLocale;
}
